import { fixedIncomeOrderResumeData } from './types';

interface FixedIncomeTableTemplateProps {
  data: fixedIncomeOrderResumeData[];
  assetCount: number;
  totalValue: string;
}

export const fixedIncomeTableTemplate = ({
  assetCount,
  data,
  totalValue,
}: FixedIncomeTableTemplateProps) => {
  if (assetCount === 0) {
    return '';
  }

  return `
      <div class="product-card">
        <strong class="product-type-title">RENDA FIXA</strong>
        <div class="product-info">
          <span class="product-info-text">${assetCount} Ativo(s)</span>
          <span class="product-info-text">Total ${totalValue}</span>
        </div>
      </div>
      <div class="product-table">
        <div class="highlight-bar fixed-income"></div>
        <div class="product-table-content">
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">ativo</th>
                <th style="width: 30px;">risco</th>
                <th style="width: 30px;">venc.</th>
                <th style="width: 30px;">rent.</th>
                <th style="width: 40px;">liquidez</th>
                <th style="width: 40px;">juros</th>
                <th style="width: 20px;">valor</th>
              </tr>
            </thead>
            <tbody>
             ${data.map((item) => {
               return `<tr>
               <td>${item.productDisplay}</td>
               <td>${item.riskRating}</td>
               <td>${item.maturityDate}</td>
               <td>${item.profitability}</td>
               <td>${item.liquidity}</td>
               <td>${item.feesPayment}</td>
               <td>${item.valueAppliedFormatted}</td>
             </tr>`;
             })}
            </tbody>
          </table>
        </div>
      </div>
      `;
};
